import { InternshipType,InternStatus } from '../service-proxies';


export class InternDto implements IInternDto {
    id!: number;
    internName!: string | undefined;
    mobileNumber!: string | undefined;
    email!: string | undefined;
    joiningDate!: Date;
    internshipType!: InternshipType;
    monthlyFee!: number;
    status!: InternStatus;
    completionDate!: Date | undefined;
    isActive!: boolean;

    constructor(data?: IInternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.internName = _data["internName"];
            this.mobileNumber = _data["mobileNumber"];
            this.email = _data["email"];
            this.joiningDate = _data["joiningDate"] ? new Date(_data["joiningDate"].toString()) : <any>undefined;
            this.internshipType = _data["internshipType"];
            this.monthlyFee = _data["monthlyFee"];
            this.status = _data["status"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InternDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["internName"] = this.internName;
        data["mobileNumber"] = this.mobileNumber;
        data["email"] = this.email;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["internshipType"] = this.internshipType;
        data["monthlyFee"] = this.monthlyFee;
        data["status"] = this.status;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IInternDto {
    id: number;
    internName: string | undefined;
    mobileNumber: string | undefined;
    email: string | undefined;
    joiningDate: Date;
    internshipType: InternshipType;
    monthlyFee: number;
    status: InternStatus;
    completionDate: Date | undefined;
    isActive: boolean;
}

